import { render, staticRenderFns } from "./CityPairs.vue?vue&type=template&id=202ba190"
import script from "./CityPairs.vue?vue&type=script&lang=js"
export * from "./CityPairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports